export default __webpack_public_path__ + "static/media/Icon-Newfeed-primary.7d7bfd0a.svg";